import { Route } from '@angular/router';
import { ROUTE_PATH } from '../../routing/RoutePath.const';

export const redirectLinkPagesRoutes: Route[] = [
  {
    path: ROUTE_PATH.BOOKING_DIRECT_LINK,
    loadChildren: () =>
      import('./booking-link-page/booking-link-page.module').then(
        (m) => m.BookingLinkPageModule
      ),
  },
  {
    path: ROUTE_PATH.QR_CHECKIN_LINK,
    loadChildren: () =>
      import('./qr-checkin-link-page/qr-checkin-link-page.module').then(
        (m) => m.QrCheckinLinkPageModule
      ),
  },
];
